import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { SuccessDialog } from '@/components/organisms/self-checkin/payment/success-dialog'
import { ErrorDialog } from '@/components/organisms/self-checkin/payment/error-dialog'
import * as vescajs from '@/apis/vescajs'
import { AccountContext } from '@/contexts/account'

type ModalProps = {
  onCancel: () => void
  onSuccess: () => void
  type: 'credit' | 'unionPay' | 'qr'
  amount: number
  salesIds: string[]
}

export const TerminalCalculateInProgressModal: React.FC<ModalProps> = props => {
  const { t } = useTranslation()
  const { account } = useContext<any>(AccountContext)
  const [receiveTerminalStatus, setReceiveTerminalStatus] = useState<'progress' | 'success' | 'error'>()
  const [vesca, setVesca] = useState<vescajs.VescaJs>()

  const onSuccess = async () => {
    setReceiveTerminalStatus('success')
    setTimeout(() => props.onSuccess(), 5000)
  }

  const doCreditPay = () => {
    vesca!.doCreditPay({
      amount: props.amount,
      tax: 0,
      unionPay: props.type === 'unionPay',
    })
  }

  const doQrPay = () => {
    vesca!.doQrPayWithQRReader({
      amount: props.amount,
      tax: 0,
    })
  }

  useEffect(() => {
    if (!vesca) {
      return
    }
    if (props.type === 'qr') {
      doQrPay()
    } else {
      doCreditPay()
    }
  }, [vesca])

  useEffect(() => {
    const vescaJs = new vescajs.VescaJs({
      hotelId: account.hotel.id,
      handler: {
        onCancel: () => {
          setReceiveTerminalStatus(undefined)
          props.onCancel()
        },
        onError: () => {
          setReceiveTerminalStatus('error')
          setTimeout(() => props.onCancel(), 5000)
        },
        onSuccess,
      },
      paymentTarget: { salesIds: props.salesIds },
    })
    setVesca(vescaJs)

    return () => {
      vescaJs.dispose()
    }
  }, [])

  if (receiveTerminalStatus === 'success') return <SuccessDialog />
  if (receiveTerminalStatus === 'error') return <ErrorDialog />
  return (
    <div css={modalWrapperStyle}>
      <div css={modalContentStyle}>
        <div css={modalCloseStyle}>
          <img src={require('@/static/images/delete_orange.svg')} width={30} onClick={props.onCancel} />
        </div>
        <div>
          <p css={modalTitleStyle}>{props.type === 'qr' ? t('Scan the guest’s QR code.') : t('Insert or tap the guest’s card.')}</p>
        </div>
        <div>
          <img src={require('@/static/images/payment_terminal_image.png')} style={{ width: '50%', paddingTop: 24 }} />
        </div>
      </div>
    </div>
  )
}

const modalWrapperStyle = css({
  width: '100vw',
  height: '100vh',
  background: 'rgba(39, 39, 39, 0.5)',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 100,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'scroll',
})

const modalContentStyle = css({
  width: 600,
  height: 350,
  background: '#fff',
  borderRadius: 5,
  display: 'flex',
  flexFlow: 'column',
  textAlign: 'center',
})

const modalCloseStyle = css({
  alignSelf: 'end',
  padding: '24px 24px 0 0',
  '>img': { cursor: 'pointer' },
})

const modalTitleStyle = css({
  color: '#272727',
  fontSize: 23,
  fontWeight: 'bold',
  lineHeight: '21px',
  letterSpacing: 1.15,
})
